import Splide from '@splidejs/splide';

interface GallerySliderOptions {
    defaults: {
        name: string;
        selectors: {
            slideContainer: string;
            thumbnailsContainer: string;
            slideControls: string;
            slideTextWrapper: string;
        };
    };
}

export function init() {
    const elements = document.querySelectorAll<HTMLElement>('.gallery-slider');
    const defaultOptions: GallerySliderOptions = {
        defaults: {
            name: 'Gallery Slider',
            selectors: {
                slideContainer: '.splide',
                thumbnailsContainer: '.gallery-slider__slider-thumbnails',
                slideControls: '.splide__controls',
                slideTextWrapper: '.gallery-slider .text-wrapper',
            },
        },
    };

    GallerySlider(elements, defaultOptions);
}

export default function GallerySlider(elements: NodeListOf<HTMLElement>, options: GallerySliderOptions) {
    process.env.NODE_ENV === 'development' &&
        console.info(`Init: ${options.defaults.name}`);

    for (let i = 0; i < elements.length; i++) {
        initSlider(elements[i], options);
    }
}

function initSlider(element: HTMLElement, options: GallerySliderOptions) {
    let splide = element.querySelector(
        options.defaults.selectors.slideContainer,
    ) as HTMLElement;

    let splideThumbnails = element.querySelector(
        options.defaults.selectors.thumbnailsContainer,
    ) as HTMLElement;

    let splideControls = element.querySelector(
        options.defaults.selectors.slideControls,
    ) as HTMLElement;

    let splideTextWrappers = element.querySelectorAll(
        options.defaults.selectors.slideTextWrapper,
    ) as NodeListOf<HTMLElement>;

    let maxHeight = 0;
    let tallestWrapper: HTMLElement | null = null;

    const slider = new Splide(splide, {
        rewind: true,
        pagination: true,
        perPage: 1,
        perMove: 1,
        arrowPath: 'm26.154 20.468 -4.164 4.18a0.66 0.66 0 0 1 -0.468 0.201 0.661 0.661 0 0 1 -0.468 -0.2 0.666 0.666 0 0 1 0 -0.954l3.027 -3.026H14.315a0.671 0.671 0 0 1 -0.669 -0.669c0 -0.368 0.301 -0.669 0.669 -0.669h9.765l-3.043 -3.043a0.666 0.666 0 0 1 0 -0.954 0.666 0.666 0 0 1 0.953 0L26.154 19.515c0.268 0.267 0.268 0.702 0 0.953Z',
        breakpoints: {
            767: {
                rewind: false,
            }
        }
    });

    slider.on('pagination:mounted', function (data) {
        data.list.classList.add('splide__pagination--custom');
        data.items.forEach(function (item) {
            let span = document.createElement('span');
            span.textContent = String(item.page + 1);
            item.button.innerHTML = '';
            item.button.appendChild(span);
            item.button.appendChild(document.createTextNode(String('/' + data.items.length)));

        });
    });

    slider.on('ready resize', function() {
        if (window.innerWidth > 768) {
            splideTextWrappers.forEach((splideTextWrapper, index) => {
                const height = splideTextWrapper.offsetHeight;
                if (height > maxHeight) {
                    maxHeight = height;
                    tallestWrapper = splideTextWrapper;
                }
            });
            const controlHeight = maxHeight + 18;
            splideControls.style.bottom = `${controlHeight}px`;
        } else {
            splideControls.style.bottom = 'unset';
        }
    });

    const sliderThumbnails = new Splide(splideThumbnails, {
        rewind: true,
        perPage: 4,
        perMove: 1,
        isNavigation: true,
        arrows: false,
        gap: 16,
        focus: 0,
        trimSpace: true,
        pagination: false,
        breakpoints: {
            767: {
                destroy: true,
            },
            768: {
                perPage: 4,
                isNavigation: true,
            }
        }
    });

    slider.sync(sliderThumbnails);
    slider.mount();
    sliderThumbnails.mount();
}
